export const SUPPLEMENTARY_MATERIAL_ACCEPTED = "SUPPLEMENTARY_MATERIAL_ACCEPTED";
export const SUPPLEMENTARY_MATERIAL_SNOOZED = "SUPPLEMENTARY_MATERIAL_SNOOZED";
